"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventivatoreProvider = void 0;
const rxjs_1 = require("rxjs");
class PreventivatoreProvider {
    // private ania;
    // private agenzia;
    constructor() {
        this.subject = new rxjs_1.Subject();
        this.comune_residenza = new rxjs_1.Subject();
        this.quotazioneSubject = new rxjs_1.Subject();
        this.modifyDatiPersonaliCalled = false;
    }
    setModifyDatiPersonaliCalled(modifyDatiPersonaliCalled) {
        this.modifyDatiPersonaliCalled = modifyDatiPersonaliCalled;
    }
    getModifyDatiPersonaliCalled() {
        return this.modifyDatiPersonaliCalled;
    }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
    setIdQuotazione(id) {
        this.idQuotazione = id;
    }
    getIdQuotazione() {
        return this.idQuotazione;
    }
    /* Gestione del passaggio dei dati della quotazione corrente*/
    getQuotazioneValue() {
        return this.quotazioneValue;
    }
    setQuotazioneValue(q) {
        this.calcola_obj.quotazioneSelezionata = q;
        this.quotazioneValue = q;
        this.setIdQuotazione(q.idQuotazione);
        this.quotazioneSubject.next(this.calcola_obj);
    }
    getQuotazioneObservable() {
        return this.quotazioneSubject.asObservable();
    }
    setCompleteCalcolaObject(obj) {
        if (obj != null && typeof obj != "undefined") {
            this.calcola_obj = obj;
            if (obj.quotazioneSelezionata) {
                this.setQuotazioneValue(obj.quotazioneSelezionata);
            }
            else {
                this.quotazioneSubject.next(obj);
            }
        }
    }
    getCompleteCalcolaObject() {
        return this.calcola_obj;
    }
    getCompleteCalcolaObjectInitial() {
        if (this.calcola_obj_initial == null) {
            this.calcola_obj_initial = JSON.parse(JSON.stringify(this.calcola_obj));
        }
        return this.calcola_obj_initial;
    }
    resetCompleteCalcolaObject() {
        return (this.calcola_obj = JSON.parse(JSON.stringify(this.calcola_obj_initial)));
    }
    getCurrentStep() {
        return this.currentStep;
    }
    getCurrentStepObservable() {
        return this.subject.asObservable();
    }
    changeCurrentStep(val) {
        this.subject.next(val);
        this.currentStep = val;
    }
    changeModifyDatiPersonali(distance) {
        //this.subject.next(distance);
    }
    getModifyDatiPersonali() {
        return this.subject.asObservable();
    }
    setComuneResidenzaLocator(str) {
        this.comune_residenza.next(str);
    }
    getComuneResidenzaLocator() {
        return this.comune_residenza.asObservable();
    }
    getbkpCalcolaObject() {
        const a = JSON.parse(this.bkpCalcolaObject);
        return a;
    }
    setbkpCalcolaObject(q) {
        this.bkpCalcolaObject = JSON.stringify(q);
    }
    setPreviousStep(previousStep) {
        this.previousStep = previousStep;
    }
    getPreviousStep() {
        return this.previousStep;
    }
}
exports.PreventivatoreProvider = PreventivatoreProvider;
